import { Component, ReactNode } from 'react'

interface Props { children: ReactNode }
interface State { error: Error | null }

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: unknown) {
    console.error('[ErrorBoundary]', error, info)
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50 p-6">
        <div className="max-w-md w-full rounded-2xl bg-white border border-slate-200 shadow-sm p-6 text-center">
          <h1 className="text-lg font-semibold text-slate-900 mb-2">Something went wrong</h1>
          <p className="text-sm text-slate-600 mb-4">
            The page failed to load. This is usually fixed by a reload — your browser may be using an outdated cached version.
          </p>
          <pre className="text-left text-[11px] text-slate-500 bg-slate-50 rounded-lg p-2 mb-4 overflow-auto max-h-32">
            {this.state.error.message}
          </pre>
          <button
            onClick={() => {
              if ('caches' in window) caches.keys().then(keys => keys.forEach(k => caches.delete(k)))
              window.location.href = '/'
            }}
            className="inline-flex items-center justify-center rounded-xl bg-[#7ABC64] hover:bg-[#5A9C4A] text-white text-sm font-medium px-4 py-2.5 transition-colors"
          >
            Reload & clear cache
          </button>
        </div>
      </div>
    )
  }
}
